import React, { useContext } from "react";
import Dashboard from "../components/Dashboard";
import { MenuContext } from "../context/menuContext";

function Home() {
	const { mobileMenu } = useContext(MenuContext);

	return (
		<div
			className={
				mobileMenu
					? "overflow-y-hidden absolute md:left-64 py-3 h-screen bg-slate-50 md:top-0 md:w-[calc(100%-16rem)] dark:bg-darkbg"
					: "absolute md:left-[13rem] lg:left-64 py-3 h-auto bg-slate-50 top-[3rem] md:top-0 md:w-[calc(100%-13rem)] lg:w-[calc(100%-16rem)] dark:bg-darkbg"
			}>
			<Dashboard />
		</div>
	);
}

export default Home;
